import { MetricOption, DateRangeOption } from 'features/admin/model/IMetrics';

export const METRIC_OPTIONS: MetricOption[] = [
    { id: 'dau', label: 'DAU (Активные за день)', color: '#FF6B6B', default: true },
    { id: 'wau', label: 'WAU (За 7 дней)', color: '#4ECDC4', default: true },
    { id: 'mau', label: 'MAU (За месяц)', color: '#45B7D1', default: true },

    { id: 'users_registered_total', label: 'Всего юзеров', color: '#98D8C8' },
    { id: 'users_registered_daily', label: 'Регистрации за день', color: '#F7DC6F' },
    { id: 'users_with_monitors', label: 'Юзеры с мониторами', color: '#BB8FCE' },
    { id: 'users_with_payments', label: 'Юзеры с платежами', color: '#85C1E9' },

    { id: 'monitors_active_total', label: 'Всего активных мониторов', color: '#F8C471' },
    { id: 'monitors_created_daily', label: 'Создано мониторов за день', color: '#82E0AA' },

    { id: 'incidents_created_daily', label: 'Новые инциденты за день', color: '#F1948A' },
    { id: 'incidents_open_total', label: 'Незакрытые инциденты', color: '#C39BD3' },

    { id: 'payments_count_daily', label: 'Кол-во оплат за день', color: '#FFEAA7'},
    { id: 'payments_sum_daily', label: 'Сумма оплат за день', color: '#DDA0DD'},
    { id: 'payments_expected_this_month', label: 'Прогноз оплат', color: '#96CEB4', default: true},
];

export const DATE_RANGES: DateRangeOption[] = [
    { id: 'week', label: 'Неделя' },
    { id: 'month', label: 'Месяц'},
    { id: 'quarter', label: 'Квартал' },
    { id: 'year', label: 'Год' },
];

const METRIC_GROUPS = {
    activity: ['dau', 'wau', 'mau'],
    users: ['users_registered_total', 'users_registered_daily', 'users_with_monitors', 'users_with_payments'],
    monitors: ['monitors_active_total', 'monitors_created_daily'],
    incidents: ['incidents_created_daily', 'incidents_open_total'],
    payments: ['payments_count_daily', 'payments_sum_daily', 'payments_expected_this_month'],
};

export const METRIC_GROUP_CONFIGS = [
    { key: 'activity', title: 'Активность', metrics: METRIC_GROUPS.activity },
    { key: 'users', title: 'Пользователи', metrics: METRIC_GROUPS.users },
    { key: 'payments', title: 'Платежи', metrics: METRIC_GROUPS.payments },
    { key: 'incidents', title: 'Инциденты', metrics: METRIC_GROUPS.incidents },
    { key: 'monitors', title: 'Мониторы', metrics: METRIC_GROUPS.monitors },
];

export const AGGREGATION_TYPES = [
    { id: 'day', label: 'День' },
    { id: 'week', label: 'Неделя' },
    { id: 'month', label: 'Месяц' },
] as const;

export type AggregationType = typeof AGGREGATION_TYPES[number]['id'];

export const METRIC_AGGREGATION_CONFIG: Record<string, {
    week: 'sum' | 'avg' | 'last_day';
    month: 'sum' | 'avg' | 'last_day';
}> = {
    dau: { week: 'avg', month: 'avg' },
    wau: { week: 'avg', month: 'avg' },
    mau: { week: 'last_day', month: 'last_day' },
    users_registered_total: { week: 'last_day', month: 'last_day' },
    users_registered_daily: { week: 'sum', month: 'sum' },
    users_with_monitors: { week: 'last_day', month: 'last_day' },
    users_with_payments: { week: 'last_day', month: 'last_day' },
    monitors_active_total: { week: 'last_day', month: 'last_day' },
    monitors_created_daily: { week: 'sum', month: 'sum' },
    incidents_created_daily: { week: 'sum', month: 'sum' },
    incidents_open_total: { week: 'last_day', month: 'last_day' },
    payments_count_daily: { week: 'sum', month: 'sum' },
    payments_sum_daily: { week: 'sum', month: 'sum' },
    payments_expected_this_month: { week: 'last_day', month: 'last_day' },
};

export const getDefaultMetrics = (): string[] => {
    return METRIC_OPTIONS
        .filter(opt => opt.default)
        .map(opt => opt.id);
};